<script>
export default {
  name: 'CpCardHeaderReactions',
  components: {
    CpButtonLink: require('../button-link').default,
    CpGrid: require('../grid').default,
    CpGridItem: require('../grid-item').default,
  },
  props: {
    post: { type: Object },
  },
  methods: {
    profile(slug) {
      return '/profile/' + slug;
    },
  },
};
</script>
<template>
  <CpGrid spread stretch-content justify="spaceBetween">
    <CpGridItem span="content" align="center">
      <a :href="profile(post.slug)">
        <img :src="post.image" class="image-user-activity" />
      </a>
      <span class="center-user">
        <div v-if="post.action == 'contributed.' && post.public == 0" class="content-2 profile-link">
          <span> Anonymous </span>
        </div>
        <a v-else class="content-2 profile-link" :class="{ 'a-hidden': !post.slug }" :href="profile(post.slug)">
          <span v-if="post.first_name">{{ post.first_name }}</span>
          <span v-if="post.last_name">{{ post.last_name }}</span>
        </a>
        <span class="content-1">{{ post.action }}</span>
      </span>
    </CpGridItem>
    <CpGridItem span="content" align="center">
      <CpButtonLink thin light-gray style="float: right" :href="profile(post.slug)">
        <span>View Profile</span>
      </CpButtonLink>
    </CpGridItem>
  </CpGrid>
</template>
<style scoped>
.image-user-activity {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  border: 2px solid var(--primary2);
  margin-right: 10px;
}

.center-user {
  display: flex;
  justify-content: center;
  align-items: center;
}

.a-hidden {
  text-decoration: none !important;
}

a.profile-link {
  color: var(--color);
}

@media screen and (max-width: 768px) {
  .image-user-activity {
    height: 22px;
    width: 22px;
  }
}
</style>
